import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`
});

// Add token to requests if it exists
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Resolves image URLs to work across different environments
 * - If URL starts with /api/uploads, prepend the backend URL
 * - If URL is already absolute (http/https), return as-is
 * - If URL starts with /, treat as local asset
 * @param {string} url - The image URL to resolve
 * @param {string} fallback - Fallback URL if the input is empty
 * @returns {string} - The resolved URL
 */
export const resolveImageUrl = (url, fallback = '/logo.png') => {
  if (!url) return fallback;
  
  // If it's a relative API path, prepend the backend URL
  if (url.startsWith('/api/uploads')) {
    return `${API_URL}${url}`;
  }
  
  // If it's an absolute URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // For other relative paths (like /logo.png), return as-is (served by frontend)
  return url;
};

export default api;
